import Box from '@mui/material/Box';
import { styled, useTheme } from '@mui/material/styles';
import { TableHeaderRow } from '@devexpress/dx-react-grid-material-ui';

const StyledHeaderCell = styled(TableHeaderRow.Cell)(({ theme }) => ({
  padding: `${theme.spacing(1.75)} ${theme.spacing(2)} !important`,
  color: theme.palette.text.secondary,
  ...theme.typography.label,
  '& b': {
    fontWeight: theme.typography.label.fontWeight
  }
}));

export const HeaderCell = ({ style: propsStyle, children, column, ...restProps }) => {
  const theme = useTheme();
  const headerAdornment = column?.headerAdornment;

  return (
    <StyledHeaderCell data-nr-col={column?.name} data-testid="grid-header-cell" column={column} {...restProps} style={propsStyle}>
      {headerAdornment ? (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: theme.spacing(0.5) }}>
          {children}
          {headerAdornment}
        </Box>
      ) : (
        children
      )}
    </StyledHeaderCell>
  );
};
